import './LoginComponent.scss';
import Button from "react-bootstrap/Button";
import React from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {toast} from "react-toastify";

import countryList from '../../assets/countryList.json';

const RegisterComponent = ({onLogin = null}) => {
    let signin = (e) => {
        e.preventDefault();
        const email = e.target.elements.email.value;
        const password = e.target.elements.password.value;
        const firstname = e.target.elements.firstname.value;
        const lastname = e.target.elements.lastname.value;
        const country = e.target.elements.country.value;
        const is_adult = e.target.elements.is_adult.value;

        fetch(global.route.register, {
            method: "post", credentials: 'include',
            body: global.getFormData({
                email: email,
                password: password,
                firstname: firstname,
                lastname: lastname,
                country: country,
                is_adult: is_adult,
                policy_accepted: true
            })
        })
            .then(response => {
                if (response.status === 200) {
                    toast.success("Benvenuto!")
                    if (onLogin !== null)
                        onLogin(response.user);
                } else {
                    global.catchError(response);
                }
            });

    }

    const getContent = () => {
        let content = [];
        content.push(<>
                <div className="d-flex justify-content-center">
                    <h3 className={"orange"}>Registrati</h3>
                </div>
                <br/>

                <Form onSubmit={signin}>
                    <Form.Group className="mb-3" controlId="email">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" placeholder="Inserisci email" required/>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="password">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" placeholder="Password" required/>
                        <Form.Text className="text-muted">
                            <small className="text-muted">La password deve contenere almeno 8 caratteri</small><br/>
                            <small className="text-muted">La password deve contenere almeno un carattere
                                MAIUSCOLO</small><br/>
                            <small className="text-muted">La password deve contenere almeno un numero</small>
                        </Form.Text>
                    </Form.Group>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="firstname">
                                <Form.Label>Nome</Form.Label>
                                <Form.Control type="text" placeholder="Nome" required/>

                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="lastname">
                                <Form.Label>Cognome</Form.Label>
                                <Form.Control type="text" placeholder="Cognome" required/>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Group className="mb-3" controlId="country">
                        <Form.Label>Paese</Form.Label>
                        <Form.Select aria-label="Default select example">
                            <option value={""}>Seleziona il paese</option>
                            {countryList.map((item) => (
                                <option key={item.code} value={item.name}>
                                    {item.name}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="terms">

                        <Form.Check type="checkbox" label={<span>Accetto i <a
                            href="https://www.iubenda.com/termini-e-condizioni/13297983"
                            target="_blank">
                                termini e condizioni d'uso
                            </a></span>} required/>

                    </Form.Group>

                    <Form.Group className="mb-3" controlId="is_adult">
                        <Form.Check type="checkbox" label="Confermo di avere più di 18 anni"/>
                    </Form.Group>

                    <div className="d-flex justify-content-center">
                        <Button variant="success" type="submit">
                            Registrati
                        </Button>
                    </div>
                </Form>
            </>
        )
        return content;
    }

    return (
        <div className="login-container">
            {getContent()}
        </div>
    );
};

export default RegisterComponent;
